// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","488":"7213179a","553":"b375c6eb","959":"a1a25b8a","977":"d75cf9f7"}[chunkId] + ".chunk.js";
};